export default {
    h1: {
        size: 1.75,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    h2: {
        size: 1.5,
        lineHeight: 1.2,
        marginBottom: 0.5,
    },
    text: {
        size: 1,
        marginBottom: 0.5,
    },
};
